<template>
    <el-drawer :title="formData.id ? '编辑公告' : '新增公告' " :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="400px"
        @close="close">
            <div class="drawer-content">
                <el-form :model="formData" ref="formData" :rules="rules" label-position="top" size="medium">
                    <el-form-item prop="targetTypes" label="推送对象:">
                        <el-checkbox-group v-model="formData.targetTypes">
                            <el-checkbox :label="5" border>厂牌</el-checkbox>
                            <el-checkbox :label="3" border>场地</el-checkbox>
                            <el-checkbox :label="2" border>艺人</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>                    
                    <el-form-item prop="title">
                        <span slot="label">公告标题：</span>
                        <el-input v-model="formData.title" maxlength="24"></el-input>
                    </el-form-item>
                    <el-form-item prop="content" label="公告内容：">
                        <el-input v-model="formData.content" type="textarea" maxlength="1000" show-word-limit :rows="10"></el-input>
                    </el-form-item>                    
                </el-form>                
            </div>
            <div class="drawer-footer">
                <el-button @click="close">关闭</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
            </div>
    </el-drawer>
</template>
<script>
const defaultFormData = {
    targetTypes: [2,3,5],
    content: "",
    title: "",
	id:''
}
export default {
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                title:[{ required: true, message: "请填写公告标题" }],
                content: [{ required: true, message: "请填写公告内容" }],
            },            
            remoteLoading: false
        }
    },
    methods:{
        show(data) {
            this.drawerShow = true;
            if (data) {                
                const formData = { ...defaultFormData, ...data };
               
                if (data.targetTypes) {
                    if (typeof data.targetTypes === 'string') {
                        formData.targetTypes = data.targetTypes.split(',').map(Number);
                    } else if (Array.isArray(data.targetTypes)) {
                        formData.targetTypes = data.targetTypes;
                    } else {
                        formData.targetTypes = [];
                    }
                } else {
                    formData.targetTypes = [];
                }
                this.formData = formData;
            } else {
                this.formData = { ...defaultFormData };
            }
        },
        close(){
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        //表单提交
        submitForm(){
			if( this.formData.targetTypes && this.formData.targetTypes.length == 0 ){
				return  this.$message.error("推送对象不能为空");
			}
            this.$refs["formData"].validate( async (valid) => {
                if(valid){
                   
                    this.btnLoading = true;
                    this.$request({
                        url: "/announce/createOrUpdate",
                        method: "POST",
                        data: {
                            ...this.formData,
							targetTypes:this.formData.targetTypes.toString()
                        },
                    })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if ( state == 1) {
                            this.$emit('onUpdate');
                            this.close();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
                }else{
                    return false;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>